"use client";
import type { PropsWithChildren } from "react";
import React, { useState } from "react";

export type Tab = { id: string; isActive: boolean; toggle: () => void };
export const TabsContext = React.createContext<Tab[] | undefined>(undefined);

export const TabsProvider = ({
  tabIds,
  children,
}: PropsWithChildren<{ tabIds: string[] }>) => {
  const [tabs, setTabs] = useState<Tab[]>();

  const isActive = (id: string) => {
    if (!tabs) return false;
    return tabs.find((tab) => tab.id === id)?.isActive ?? false;
  };

  const toggleTab = (id: string) => {
    if (!tabs) return;
    const newTabs = tabs.map((tab) => {
      if (tab.id === id) {
        return {
          ...tab,
          isActive: true,
        };
      }
      return { ...tab, isActive: false };
    });
    setTabs(newTabs);
  };

  const initialTabs = tabIds.map((id, i) => {
    if (i === 0) return { id, isActive: true, toggle: () => {} };
    return {
      id,
      isActive: isActive(id),
      toggle: () => toggleTab(id),
    };
  });
  if (!tabs) setTabs(initialTabs);

  const formattedTabs = tabIds.map((id) => ({
    id,
    isActive: isActive(id),
    toggle: () => toggleTab(id),
  }));

  return (
    <TabsContext.Provider value={formattedTabs}>
      {children}
    </TabsContext.Provider>
  );
};
